import { useNavigate, useRoutes } from "react-router-dom";
import pagesData from "./pagesData";
import { useEffect } from "react";

const Router = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const path = pagesData.map((ele) => ele.path)

  useEffect(() => {
    if (!token && window.location.pathname === "/dashboard") {
      navigate("/");
    } else if (token && window.location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [token]);

  return useRoutes(pagesData);
};

export default Router;